import axios from 'axios';
import { VerifyAuth } from './axiosInterceptor';

const API = process.env.REACT_APP_API_PATH;


export const getClientbyClientId = async (companyMasterId,token) => {
  try {

    return await axios
      .get(`${API}/getClientbyClientId/${companyMasterId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization":`Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};


export const getClients = async (token) => {
  try {

    return await axios
      .get(`${API}/getClients`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization":`Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const addClient = async (data,token) => {
  console.log('data', data);
  console.log('token', token);
  try {

    return await axios
      .post(`${API}/addClient`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization":`Bearer ${token}`
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const deleteClient = async (companyMasterId, token, gmtOffset, userLogId) => {
  try {

    return await axios
      .delete(`${API}/deleteClient/${companyMasterId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization":`Bearer ${token}`,
          "gmtOffset": gmtOffset,
          "userLogId": userLogId
        },
      })
      .then((res) => {
        console.log('res.data', res.data);
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};


export const active_inative = async (companyMasterId, token, gmtOffset, userLogId) => {
  try {

    return await axios
      .delete(`${API}/active_inative/${companyMasterId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization":`Bearer ${token}`,
          "gmtOffset": gmtOffset,
          "userLogId": userLogId
        },
      })
      .then((res) => {
        console.log('res.data', res.data);
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};